<div class="opacity-slider-component">
  <mat-slider class="opacity-slider" #ngSlider min="0" max="100">
    <input matSliderThumb [(ngModel)]="opacityTimes100" (change)="emitOpacityChange()" #ngSliderThumb="matSliderThumb" />
  </mat-slider>
</div>
